import { CallFilters } from 'src/interfaces/call.interface';

export const formatCallFiltersForApi = (filters: CallFilters): CallFilters => {
  const hasWorkflowReferenceIdFilter =
    filters.workflow_reference_id &&
    filters.workflow_reference_id !== 'All Campaigns';

  const callContext = {
    ...(filters.call_context || {}),
    ...(hasWorkflowReferenceIdFilter && {
      '$fluents:workflows:workflow_reference_id': filters.workflow_reference_id,
    }),
  };

  const formattedFilters: CallFilters = {
    ...filters,
    ...(filters.agent === 'All Agents' && { agent: undefined }),
    workflow_reference_id: undefined,
    ...((filters.status === 'All Statuses' ||
      filters.status === 'voicemail' ||
      filters.status === 'is_not_voicemail') && { status: undefined }),
    ...(filters.status === 'voicemail' && { is_voicemail: true }),
    ...(filters.status === 'is_not_voicemail' && { is_voicemail: false }),
    ...(filters.successful_actions?.length === 0 && {
      successful_actions: undefined,
    }),
    ...(filters.call_id === '' && { call_id: undefined }),
    ...((filters.post_call_insights?.children.length ?? 0) === 0 && {
      post_call_insights: undefined,
    }),
    call_context: Object.keys(callContext).length > 0 ? callContext : undefined,
  };

  return Object.fromEntries(
    Object.entries(formattedFilters).filter(([, value]) => value !== undefined),
  ) as CallFilters;
};
